'use strict';

angular.module('licensure.services')
    .factory('LicenseChargeTypes', ['$http', '$q', function ($http, $q) {
        return {
            get: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licensechargetypes', {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getCountFromQuery: function (chargeTypeId, licenseRequestId) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licensechargetypes/getcountfromquery', {
                        params: {
                            chargeTypeId: chargeTypeId,
                            licenseRequestId: licenseRequestId
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;